import { render, staticRenderFns } from "./exampleDetail.vue?vue&type=template&id=463407da&scoped=true&"
import script from "./exampleDetail.vue?vue&type=script&lang=js&"
export * from "./exampleDetail.vue?vue&type=script&lang=js&"
import style0 from "./exampleDetail.vue?vue&type=style&index=0&id=463407da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463407da",
  null
  
)

export default component.exports